import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import ListIcon from '@mui/icons-material/List';
import Badge from "@mui/material/Badge";

import COLOR_THEMES from "../../../../../colorThemes";
import {GroheGridIcon} from "../../../../common/icons";
import {setGroheFiltersOpened} from "../../../../../actions/groheFunctions";
import {setLookViewType} from "../../../../../actions/lookFunctions";
import LookMainCategory from "../../../lookNavigation/lookMain/lookCategory/lookMainCategory";
import GroheSvgFilterIcon from "../groheFilters/groheFiltersIcon";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {
  getCurrentGroups,
  getFeatureGroupFromWizardGroup
} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";

const GroheFeaturesHeader = (props) => {

  const {lookActiveCategory, filtersOpened, setGroheFiltersOpened, intl, activeTheme, filtersVisible,
    lookViewType, setLookViewType, lookOpened, isMobile, selectedFiltersLength} = props;

  const filtersButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFiltersOpen);
    setGroheFiltersOpened(!filtersOpened);
  }

  const viewButtonClick = () => {
    const newViewType = lookViewType === 1 ? 2 : 1;
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesListViewType + newViewType);
    setLookViewType(newViewType);
  }

  if (isMobile) {
    return (
      <section className={"grohe-features" + (lookActiveCategory && lookOpened ? " grohe-features--opened" : "")}>
        {lookActiveCategory ? <LookMainCategory/> : null}
      </section>
    )
  }

  return (
    <header className="grohe-sidebar__header">
      {filtersVisible ? (
        <div className="grohe-sidebar__header-cell">
          <Badge badgeContent={selectedFiltersLength} color="primary" invisible={!selectedFiltersLength}>
            <IconButton aria-label={intl.formatMessage({id:"grohe.features.filters"})}
                        className={"look-icon look-icon--small look-icon__grohe" + (filtersOpened ? " look-icon--active" : "")}
                        onClick={filtersButtonClick}>
              <GroheSvgFilterIcon/>
            </IconButton>
          </Badge>
          <span className="grohe-sidebar__header-button-text"
                onClick={filtersButtonClick}>
            <FormattedMessage id="grohe.features.filters"/>
          </span>
        </div>
      ) : null}
      <div className="grohe-sidebar__header-cell grohe-sidebar__header-cell--look-type">
        <IconButton aria-label={intl.formatMessage({id:lookViewType === 1 ? "grohe.features.listButton" : "grohe.features.gridButton"})}
                    className={"look-icon look-icon--small look-icon__grohe"}
                    onClick={viewButtonClick}>
          {lookViewType === 1 ? <ListIcon/> : (
            <SvgIcon>
              <GroheGridIcon color={COLOR_THEMES[activeTheme].primary}/>
            </SvgIcon>
          )}
        </IconButton>
        <span className="grohe-sidebar__header-button-text"
              onClick={viewButtonClick}>
          <FormattedMessage id={lookViewType === 1 ? "grohe.features.listButton" : "grohe.features.gridButton"}/>
        </span>
      </div>
    </header>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookViewType, lookOpened} = store.lookState;
  const {activeTheme, isMobile} = store.serverState;
  const {filtersOpened, groheFiltersSearchText} = store.groheState;
  const {selectedFilters} = store.filterState;
  const fabricatorData = store.fabricatorState;
  const {wizardSelectedValues, wizardActiveItem, wizardActiveStep} = store.wizardState;

  let selectedFiltersLength = selectedFilters.length;
  if (groheFiltersSearchText) {
    selectedFiltersLength += 1;
  }

  let filtersVisible = true;
  if (fabricatorData.isSolidSurface) {
    if (!wizardActiveItem) {
      filtersVisible = lookActiveCategory === "vanity_countertop"
    }
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (currentGroups.length === 1) {
      const featureGroup = getFeatureGroupFromWizardGroup(currentGroups[0]);
      filtersVisible = featureGroup && featureGroup.partId === "vanity_countertop"
    }
  }

  return {
    lookOpened,
    lookViewType,
    lookActiveCategory,
    activeTheme,
    filtersOpened,
    isMobile,
    selectedFiltersLength,
    filtersVisible,
  };
};

const mapDispatchToProps = {
  setGroheFiltersOpened,
  setLookViewType,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeaturesHeader)
)
